module.exports = __webpack_public_path__ + "footlogo.png?0f7e191f7fbd3f64469790fb03523c32";